import { Search, ShieldAlert, ShieldCheck, BadgeCheck } from "lucide-react";
import { PROCESS } from "@/data/siteContent";

const ICONS = { Search, ShieldAlert, ShieldCheck, BadgeCheck };

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-20 md:py-32 bg-white dark:bg-[#0A2513]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span
              className="inline-block text-xs uppercase tracking-[0.18em] font-semibold text-[#1F8A3A]"
              data-testid="process-eyebrow"
            >
              Our process
            </span>
            <h2
              data-testid="process-heading"
              className="mt-4 font-display text-3xl md:text-5xl font-semibold tracking-tight text-[#0E2A17] dark:text-[#F2FAF4]"
            >
              Four steps from discovery to verified clean.
            </h2>
          </div>
          <p className="text-base text-[#3F5549] dark:text-[#B9CDC0] max-w-md">
            A transparent, predictable workflow so you know exactly what's
            happening in your home — at every stage.
          </p>
        </div>

        <div className="mt-16 relative">
          <div className="hidden md:block absolute top-[58px] left-[8%] right-[8%] h-[2px] bg-gradient-to-r from-transparent via-[#7BC7A3] to-transparent" />
          <ol className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
            {PROCESS.map((p, i) => {
              const Icon = ICONS[p.icon] || Search;
              return (
                <li
                  key={p.step}
                  data-testid={`process-step-${p.step}`}
                  className="relative"
                >
                  <div className="relative z-10 flex flex-col items-start md:items-center text-left md:text-center">
                    <div className="relative">
                      <div className="h-[116px] w-[116px] rounded-full bg-[#F2FAF4] dark:bg-[#0E2A17] flex items-center justify-center border border-[#E3F5EA] dark:border-[#1A3925]">
                        <Icon className="h-10 w-10 text-[#1F8A3A]" />
                      </div>
                      <span className="absolute -top-2 -right-2 rounded-full bg-[#0E2A17] text-white text-xs font-semibold h-8 w-8 flex items-center justify-center font-display">
                        {p.step}
                      </span>
                    </div>
                    <h3 className="mt-6 font-display text-xl font-semibold text-[#0E2A17] dark:text-[#F2FAF4]">
                      {p.title}
                    </h3>
                    <p className="mt-2 text-sm text-[#3F5549] dark:text-[#B9CDC0] leading-relaxed max-w-[260px]">
                      {p.description}
                    </p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}
